const orbOfShieldingList = require('./orbOfShieldingList')

const siblingIdList = orbOfShieldingList.map(({id}) => id)

module.exports = siblingIdList
